import { Button } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const styles = (theme) => {
    const { zenputColors, spacing } = theme;

    return {
        root: {
            backgroundColor: zenputColors.accent1,
            color: zenputColors.white,
            padding: spacing(2),
            borderRadius: 0,
            display: 'block',
            width: '100%',

            '&:hover': {
                backgroundColor: zenputColors.accent1
            }
        }
    };
};
const ActionButton = withStyles(Button, styles);

export default ActionButton;
